import { View, Platform } from 'react-native'

import styled from 'styled-components/native'
import theme from '../../../styles/theme'

const { gutterUnit } = theme

export const TableSection = styled(View)`
  borderBottomColor: ${theme.colours.bordergrey};
  borderBottomWidth: 1px;
  borderLeftColor: ${theme.colours.bordergrey};
  borderLeftWidth: 1px;
  borderRightColor: ${theme.colours.bordergrey};
  borderRightWidth: 1px;
`

export const TableHeader = styled(TableSection)`
  background-color: ${theme.colours.darkBlue};
`

export const Row = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const Column = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 ${2 * gutterUnit}px;
`

export const borderHack = Platform.select({
  web: {},
  default: {
    borderBottomColor: theme.colours.bordergrey,
    borderBottomWidth: 0.5
  }
})
